import React from 'react';

import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const ButtonLoaderAtom = (props) => {
  const { active,color } = props;
  if (!active) return null;
  return (
    <span className={styles['ball-clip-rotate']}>
      <div style={{border:color?`2px solid ${color}`:null}}/>
    </span>
  );
};

ButtonLoaderAtom.propTypes = {
  active: PropTypes.bool.isRequired,
};

export default ButtonLoaderAtom;
